module.exports = global["Phaser"] = require("-!./phaser.js");